import React from "react";
import { XO_PAPER } from "./xoConvergenceBrand";

export type XOPublicQuietLoadingProps = {
  /** Short line — avoid spinner chrome */
  label?: string;
};

/**
 * Subtle first-paint / lazy-route placeholder for public ink surfaces.
 */
export function XOPublicQuietLoading({ label = "Loading surface…" }: XOPublicQuietLoadingProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "40vh",
        padding: "48px 24px",
        boxSizing: "border-box",
        color: "rgba(246, 240, 230, 0.55)",
        fontSize: "0.8125rem",
        fontWeight: 400,
        letterSpacing: "0.02em",
        lineHeight: 1.45,
        textAlign: "center",
      }}
    >
      <span style={{ color: XO_PAPER, opacity: 0.72 }}>{label}</span>
    </div>
  );
}
